import React from 'react';
import {Route, Switch} from "react-router";
import {BrowserRouter} from "react-router-dom";
import {Location} from 'history';
import ReservedRoute from "./ReservedRoute";
import {PermissionContext} from "../context/PermissionContext";

import {VerticalLayout} from "../layout/VerticalLayout";
import MissingPath from "../components/MissingPath";
import Header from "../layout/Header";
//import UserRegistry from "../controller/UserRegistry";
import ReservedSwitcher, {
    ADMIN_ROLE,
    LAB_REDIRECT,
    LAB_ROLE,
    PUNTI_PRELIEVO_REDIRECT,
    PUNTI_PRELIEVO_ROLE,
    REQUESTS_REDIRECT,
    USER_REDIRECT,
    USER_ROLE
} from "../components/ReservedSwitcher";
import AdminController from "../controller/AdminController";
import Footer from "../layout/Footer";
import {Flex} from "../components/styled/Flex";
import {useKeycloak} from "@react-keycloak/web";
import Spinner from "../layout/Spinner";

//import InformativaProgetto from "../components/view/InformativaProgetto";


//import UserContainer from "../controller/UserContainer";
//import LaboratoryController from "../controller/LaboratoryController";
//import PuntoPrelievoController from "../controller/PuntoPrelievoController";

const UserRegistry = React.lazy(() => import("../controller/UserRegistry"));
const UserContainer = React.lazy(() => import("../controller/UserContainer"));
const LaboratoryController = React.lazy(() => import("../controller/LaboratoryController"));
const PuntoPrelievoController = React.lazy(() => import("../controller/PuntoPrelievoController"));
const InformativaProgetto  = React.lazy(() => import("../components/view/InformativaProgetto"));

interface AppRouterInterface {

}

const AppRouter: React.FC<AppRouterInterface> = (props) => {

    const {keycloak, initialized} = useKeycloak();
    const {authenticated} = keycloak;
    const permissionManager = React.useContext(PermissionContext);


    React.useEffect(() => {
        if (authenticated) {
            permissionManager.updateFromToken(keycloak);
        }
    }, [authenticated]);


    const header = (

        <Header
            style={{
                width: '100%',
                backgroundColor: 'white',
                borderBottom: '1px solid lightblue'
            }}
        />

    );


    const routes = (
        <Switch>
            <Route path={'/gip/setup'}>
                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <UserRegistry/>
                </VerticalLayout>
            </Route>

            <Route path={'/gip/informativa'}>
                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <InformativaProgetto/>
                </VerticalLayout>
            </Route>





            <ReservedRoute
                path={`${USER_REDIRECT}`}
                error={
                    <VerticalLayout style={{backgroundColor: 'transparent'}}>
                        <ReservedSwitcher/>
                    </VerticalLayout>
                }

                onAuthenticated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // console.log('onAuthenticated  ', '/user');;
                    permissionManager.updateFromToken(token);
                }}
                onError={(error: any, location: Location) => {
                    //console.log('Error: ', error);
                }}
                onUpdated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // console.log('Match: ', match);
                    // setToken(token);
                    // console.log('onUpdated  ', '/user');
                    permissionManager.updateFromToken(token);

                }}

                checkParams={(params: any) => {
                    //console.log('CheckParams: ', params);
                    return (keycloak.hasRealmRole(USER_ROLE) || keycloak.hasResourceRole(USER_ROLE));
                    //return true;
                }}
            >
                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <UserContainer/>
                </VerticalLayout>

            </ReservedRoute>


            <ReservedRoute
                path={`${PUNTI_PRELIEVO_REDIRECT}`}
                error={
                    <VerticalLayout style={{backgroundColor: 'transparent'}}>
                        <ReservedSwitcher/>
                    </VerticalLayout>
                }

                onAuthenticated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // console.log('onAuthenticated  ', PUNTI_PRELIEVO_REDIRECT);
//                    auth.updateToken(token);
                    permissionManager.updateFromToken(token);
                }}
                onError={(error: any, location: Location) => {
                    // console.log('Error: ', error);
                }}
                onUpdated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // // console.log('Match: ', match);
                    // setToken(token);
                    // console.log('onUpdated  ', PUNTI_PRELIEVO_REDIRECT);
                    permissionManager.updateFromToken(token);
                   // auth.updateToken(token);
                }}
                checkParams={(params: any) => {
                    // console.log('PIP: ', params);
                    return (keycloak.hasRealmRole(PUNTI_PRELIEVO_ROLE) || keycloak.hasResourceRole(PUNTI_PRELIEVO_ROLE));
                    // return true;
                }}
            >
                        <VerticalLayout style={{backgroundColor: 'transparent'}}>
                            <PuntoPrelievoController/>
                        </VerticalLayout>

            </ReservedRoute>

            <ReservedRoute
                path={`${LAB_REDIRECT}`}
                error={
                    <VerticalLayout style={{backgroundColor: 'transparent'}}>
                        <ReservedSwitcher/>
                    </VerticalLayout>
                }

                onAuthenticated={(token: Keycloak.KeycloakInstance, location: Location) => {
                   // auth.updateToken(token);
                    permissionManager.updateFromToken(token);
                }}
                onError={(error: any, location: Location) => {
                    // console.log('Error: ', error);
                }}
                onUpdated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // // console.log('Match: ', match);
                    // setToken(token);
                    permissionManager.updateFromToken(token);
                   // auth.updateToken(token);
                }}
                checkParams={(params: any) => {
                    // console.log('LABS: ', params);
                    return (keycloak.hasRealmRole(LAB_ROLE) || keycloak.hasResourceRole(LAB_ROLE));
                    //return true;
                }}
            >

                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <LaboratoryController/>
                </VerticalLayout>

            </ReservedRoute>



            <ReservedRoute
                path={`${REQUESTS_REDIRECT}`}
                error={
                    <VerticalLayout style={{backgroundColor: 'transparent'}}>
                        <ReservedSwitcher/>
                    </VerticalLayout>

                }

                onAuthenticated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    console.log('ONAUTHENTICATED: ', token);
                    permissionManager.updateFromToken(token);
                }}
                onError={(error: any, location: Location) => {
                    // console.log('Error: ', error);
                }}
                onUpdated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // // console.log('Match: ', match);
                    // setToken(token);
                    permissionManager.updateFromToken(token);
                   // auth.updateToken(token);
                }}
                checkParams={(params: any) => {
                    // console.log('LABS: ', params);
                    return (keycloak.hasRealmRole(ADMIN_ROLE) || keycloak.hasResourceRole(ADMIN_ROLE));
                    //return true;
                }}
            >
                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <AdminController/>
                </VerticalLayout>

            </ReservedRoute>






            <ReservedRoute
                path={'/gip'}
                error={
                    <div>Errnor</div>
                }

                onAuthenticated={(token: Keycloak.KeycloakInstance, location: Location) => {
                   // auth.updateToken(token);
                    permissionManager.updateFromToken(token);
                }}
                onError={(error: any, location: Location) => {
                    // console.log('Error: ', error);
                }}
                onUpdated={(token: Keycloak.KeycloakInstance, location: Location) => {
                    // // console.log('Match: ', match);
                    // setToken(token);
                    permissionManager.updateFromToken(token);
                    //auth.updateToken(token);
                }}
                checkParams={(params: any) => {
                    return true;
                }
                }
            >

                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <ReservedSwitcher/>
                </VerticalLayout>

            </ReservedRoute>

            <Route path={'*'}>
                <VerticalLayout style={{backgroundColor: 'transparent'}}>
                    <MissingPath/>
                </VerticalLayout>
            </Route>
        </Switch>
    );

    const component = (
        initialized ?
            <BrowserRouter>
                <Flex direction={'column'}>
                {header}
                <main style={{display: 'flex', flexDirection: 'column', width: '100vw'}}>

                        <div
                            style={{
                                width: '100%',
                                paddingLeft: '30px', paddingRight: '30px', marginTop: '1vh'
                            }}
                        >
                            {routes}
                        </div>

                    {/*

*/}
                </main>
                </Flex>
                <Footer/>
            </BrowserRouter> :
            <Spinner/>
    );


    return(
        <>
        {component}
        </>
    )
};

export default AppRouter;